var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/travis/build/SouthAmericansSecrets/web/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["partials/article.en.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "items");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\t<div class=\"row container-article\">\n\t\t<div class=\"col-sm-12 col-md-12 no-padding\">\n\t\t\t<img class=\"article-image\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"url_image"), env.opts.autoescape);
output += "\" alt=\"\" width=\"100%\">\n\t\t</div>\n\t\t<div class=\"col-sm-12 col-md-12\">\n\t\t\t<div class=\"row article article-body\">\n\t\t\t\t<div class=\"col-lg-12\">\n\t\t\t\t\t<div class=\"article-title\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "</div>\n\t\t\t\t\t<div class=\"article-author\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"date"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"author"), env.opts.autoescape);
output += "</div>\n\t\t\t\t\t<div class=\"article-subtitle\">\n\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"subtitle"), env.opts.autoescape);
output += "\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class=\"text-justify\">\n\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"description"), env.opts.autoescape);
output += "\n\t\t\t\t\t</p>\n\t\t\t\t\t";
if(runtime.memberLookup((t_4),"blockquote")) {
output += "\n\t\t\t\t\t\t<blockquote class=\"article-blockquote\">\n\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_4),"blockquote"), env.opts.autoescape);
output += "\n\t\t\t\t\t\t</blockquote>\n\t\t\t\t\t";
;
}
output += "\n<div class=\"share dropdown\">\n    <button class=\"btn read-more dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">\n       ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "share"), env.opts.autoescape);
output += " <i class=\"fa fa-share\" aria-hidden=\"true\"></i>\n    </button>\n    <ul class=\"dropdown-menu dropdown-menu-right\">\n        <div id=\"share-buttons\">\n            <a href=\"http://www.facebook.com/sharer.php?u=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <img src=\"images/facebook.png\" alt=\"Facebook\" />\n            </a>\n            <a href=\"https://plus.google.com/share?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <img src=\"images/google.png\" alt=\"Google\" />\n            </a>\n            <a href=\"http://www.linkedin.com/shareArticle?mini=true&amp;url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                <img src=\"images/linkedin.png\" alt=\"LinkedIn\" />\n            </a>\n            <a href=\"http://reddit.com/submit?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "&amp;title=South Americans Secrets\" target=\"_blank\">\n                <img src=\"images/reddit.png\" alt=\"Reddit\" />\n            </a>\n            <a href=\"https://twitter.com/share?url=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "uri"), env.opts.autoescape);
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "&amp;text=South%20Americans%20Secrets&amp;hashtags=southamericanssecrets\" target=\"_blank\">\n                <img src=\"images/twitter.png\" alt=\"Twitter\" />\n            </a>\n        </div> \n    </ul>\n</div>\n                \t";
if(runtime.memberLookup((t_4),"link")) {
output += "\n                \t    <button class=\"read-more\" onclick=\"changeUriPath('";
output += runtime.suppressValue(runtime.memberLookup((t_4),"link"), env.opts.autoescape);
output += "')\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "link"), env.opts.autoescape);
output += "</button>\n                \t";
;
}
output += "\n\t\t\t\t\t";
if(runtime.memberLookup((t_4),"tour")) {
output += "\n\t\t\t\t\t\t<button class=\"read-more\" onclick=\"changeUriPath('";
output += runtime.suppressValue(runtime.memberLookup((t_4),"tour"), env.opts.autoescape);
output += "')\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sTour"), env.opts.autoescape);
output += "</button>\n\t\t\t\t\t";
;
}
output += "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n  </div>\n";
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["partials/article.en.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./app/tpl/partials/article.en.njk
// module id = 183
// module chunks = 59